/*!
 * GWINS no-autoplay.js v2 — aggressive Swiper autoplay killer.
 * v2 approach:
 *  1) Monkey-patch window.Swiper BEFORE Jhango's product.js inits galleries,
 *     so every new Swiper instance is forced to autoplay: false.
 *  2) Also kill any instance already constructed.
 *  3) Continuous kill loop for the first 15 seconds of page life.
 *  4) MutationObserver for late DOM (quick-view, variant swap).
 *  5) Scope BROAD on product pages: any .swiper not inside a card /
 *     recommendations / thumbnails gets its autoplay killed.
 * Added: 2026-11-05.
 */
(function () {
  'use strict';

  function onProductPage() {
    try {
      return document.body.classList.contains('page-type-product')
        || document.body.classList.contains('template-product')
        || !!document.querySelector('[data-section-type="product-main"], #product-main, main [data-section-id*="product"]');
    } catch (e) { return false; }
  }

  function isKillableSwiperEl(el) {
    try {
      if (!el || !el.closest) return false;
      // Never touch these: product cards, recommendations, thumbnails rail.
      if (el.closest('.product-card, .card-product, [data-section-type="product-recommendations"], [data-section-type="recommended-products"], .swiper-thumbs, .thumbs-swiper, [data-swiper="thumbs"]')) {
        return false;
      }
      // Product-page swipers (main gallery): kill autoplay.
      if (onProductPage()) return true;
      // Quick-view modal galleries on any page.
      if (el.closest('.modal[id*="quick"], [data-modal*="quick"], .offcanvas[id*="quick"]')) return true;
      return false;
    } catch (e) { return false; }
  }

  function killInstance(inst) {
    try {
      if (!inst) return;
      if (inst.params) { inst.params.autoplay = false; }
      if (inst.autoplay) {
        if (typeof inst.autoplay.stop === 'function') inst.autoplay.stop();
        if (typeof inst.autoplay.pause === 'function') inst.autoplay.pause();
        inst.autoplay.running = false;
        inst.autoplay.paused = true;
      }
    } catch (e) {}
  }

  function killExisting() {
    try {
      document.querySelectorAll('.swiper').forEach(function (el) {
        if (!isKillableSwiperEl(el)) return;
        killInstance(el.swiper);
      });
    } catch (e) {}
  }

  // --- 1. Monkey-patch window.Swiper so every new instance is autoplay-free. ---
  function patchSwiperConstructor() {
    if (!window.Swiper) return false;
    if (window.Swiper.__gwinsPatched) return true;
    try {
      var Original = window.Swiper;
      function Patched(el, opts) {
        opts = opts || {};
        var isKill = false;
        try { isKill = isKillableSwiperEl(typeof el === 'string' ? document.querySelector(el) : el); } catch (e) {}
        if (isKill && opts.autoplay) { opts.autoplay = false; }
        var inst = new Original(el, opts);
        if (isKill) { killInstance(inst); }
        return inst;
      }
      Object.keys(Original).forEach(function (k) {
        try { Patched[k] = Original[k]; } catch (e) {}
      });
      Patched.prototype = Original.prototype;
      Patched.__gwinsPatched = true;
      window.Swiper = Patched;
      return true;
    } catch (e) { return false; }
  }

  // Retry patching Swiper until it's defined (up to ~5 s).
  var patchTries = 0;
  var patchInt = setInterval(function () {
    patchTries++;
    if (patchSwiperConstructor() || patchTries > 200) {
      clearInterval(patchInt);
    }
  }, 25);

  // --- 2. Continuous kill loop for first 15 s of page life. ---
  var killTries = 0;
  var killInt = setInterval(function () {
    killTries++;
    killExisting();
    if (killTries > 150) clearInterval(killInt);
  }, 100);

  // --- 3. Observe DOM for late-added swipers. ---
  function startObserver() {
    try {
      var obs = new MutationObserver(function () { killExisting(); });
      obs.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }
  if (document.body) { startObserver(); }
  else { document.addEventListener('DOMContentLoaded', startObserver); }

  // --- 4. Final sweep on load. ---
  window.addEventListener('load', function () { killExisting(); });
})();
